import React, { useState, useEffect, useCallback } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS
import "ag-grid-community/styles/ag-theme-alpine.css"; // Alpine theme CSS
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PropTypes from "prop-types";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import useBusinessEntryApiCall from "customApiHooks/useBusinessEntryApiCall";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { Tooltip } from "@mui/material";
import CurrencyInput from "react-currency-input-field";
import Cookie from "js-cookie";
import {
  Switch,
  Grid,
  MenuItem,
  Checkbox,
  TableContainer,
  Paper,
  TextField,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  CircularProgress,
  Typography,
  Autocomplete,
  InputAdornment,
  Popover,
  Box,
  FormControlLabel,
  Tab,
  Tabs,
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  Table,
  RadioGroup,
  Radio,
} from "@mui/material";
import MDBox from "components/MDBox";
import {
  ViewButton,
  DeleteButton,
  StyledTypography,
  StyledTypographyA,
  StyledTypographyAA,
  StyledButton,
  StyledButtonC,
  StyledAlert,
  StyledSnackbar,
  StyledIconButton,
  StyledButtonAbort,
  StyledButtonAnchor,
  inputStyle,
  StyledAgGridContainer,
  CustomSwitch,
  StyledTableContainer,
  CustomTableCell,
} from "components/StyledComponents/styledComponents.js";
import DisbursementTabs from "./EntryComponents/disbursements";
import { subDialogContentStyle, dialogContentTextStyle } from "components/Styles/approvalStyles";
import { tableShadow, globalStyles, CustomPaper } from "components/Styles/globalStyles";
import useBusinessMonthYear from "components/GlobalHooks/useMonthlyBusiness";
import { entryStyles } from "components/Styles/loanEntryStyles";
import ResponsiveTabs from "components/StyledComponents/styledComponents";
import FilterSection from "components/Forms/BusinessEntry/EntryComponents";
import { useMaterialUIController } from "context";
import URLs from "constants/urls";
export default function BusinessEntry() {
  const [controller] = useMaterialUIController();
  const { user } = controller;
  const [isForwarded, setIsForwarded] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedManager, setSelectedManager] = useState("");
  const [selectedDSA, setSelectedDSA] = useState("");
  const [selectedSubDSA, setSelectedSubDSA] = useState(-1);
  const [selectedLoanType, setSelectedLoanType] = useState("");
  const [selectedAppliedTo, setSelectedAppliedTo] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [providerPayout, setProviderPayout] = useState("");
  const [dsaPayout, setDSAPayout] = useState("");
  const [selectedDsaSalesManager, setSelectedDsaSalesManager] = useState("");
  const [applicationNumber, setApplicationNumber] = useState("");
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [LoanAmount, setLoanAmount] = useState("");
  const [remarks, setRemarks] = useState("");
  const [entryId, setEntryId] = useState("");
  const [serviceEntryId, SetServiceEntryId] = useState("");
  const [subDsaPayout, setSubDsaPayout] = useState(0);
  const [subDsaId, setSubDsaId] = useState(0);
  const [serviceTypeCode, setServiceTypeCode] = useState("BL");
  const [grossPayoutAmount, setGrossPayoutAmount] = useState(0);
  const [dsaPayoutAmount, setDsaPayoutAmount] = useState(0);
  const [dsaStatus, setDsaStatus] = useState(false);
  const [businessMonthId, setBusinessMonthId] = useState(0);
  const [businessStatus, setBusinessStatus] = useState("N");
  const [filteredSubDsaManagers, setFilteredSubDsaManagers] = useState([]);
  const [dsaTdsPercent, setDsaTdsPercent] = useState("");
  const [subDsaTdsPercent, setSubDsaTdsPercent] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [openDailogAbortBox, setOpenDailogAbortBox] = useState(false);
  const [unAbortbox, setUnAbortBox] = useState(false);
  const [businessStatusFilter, setBusinessStatusFilter] = useState(0);
  const [disbursedAmount, setDisbursedAmount] = useState("");
  const [loginDate, setLoginDate] = useState(new Date().toISOString().slice(0, 10));
  const [anchorEl, setAnchorEl] = useState(null);
  const jwt_token = Cookie.get("jwt_token");
  const [productType, setProductType] = useState("");
  const [disbursements, setDisbursements] = useState([]);
  const [selectedEntryData, setSelectedEntryData] = useState({});
  const [entryCondition, setEntryCondition] = useState({});
  const [connectorFormData, setConnectorFormData] = useState({
    connectorId: "",
    connectorName: "",
    panNumber: "",
    hasGST: false,
    gstNumber: "",
  });
  const [connectorData, setConnectoreData] = useState([]);
  const [localConnectorData, setLocalConnectorData] = useState(connectorData || []);
  const [actualDsaPayout, setActualDsaPayout] = useState("");
  const [disbursedState, setDisbursedState] = useState(false);
  const [selectedDisbursement, setSelectedDisbursement] = useState(null);
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth(); // 0-based index
  const [assignedTo, setAssignedTo] = useState(user.companyId || -2);
  const startOfMonth = new Date(year, month, 2).toISOString().split("T")[0];
  const endOfMonth = new Date(year, month + 1, 1).toISOString().split("T")[0];

  const [fromDate, setFromDate] = useState(startOfMonth);
  const [toDate, setToDate] = useState(endOfMonth);
  const [payouts, setPayouts] = useState({
    providerPayoutAmount: 0,
    tdsOnProviderPayout: 0,
    finalProviderPayoutAmount: 0,
    dsaPayoutAmountD: 0,
    tdsOnDsaPayout: 0,
    finalDsaPayoutAmount: 0,
    connectorPayout: 0,
    tdsOnConnectorPayout: 0,
    finalConnectorPayoutAmount: 0,
  });
  const handleConnectorChange = (e) => {
    const { name, value } = e.target;
    setConnectorFormData({ ...connectorFormData, [name]: value });
  };
  const handleOpenPopover = (event) => setAnchorEl(event.currentTarget);
  const handleClosePopover = () => setAnchorEl(null);
  const handleConnectorSave = async () => {
    if (
      !connectorFormData.connectorId ||
      !connectorFormData.connectorName ||
      !connectorFormData.panNumber
    ) {
      setAlert("Please fill in Connector ID and Connector Name and PanNumber", "error");
      return;
    }

    if (connectorFormData.hasGST && !connectorFormData.gstNumber) {
      setAlert("Please enter the GST Number.", "error");
      return;
    }
    const newConnector = { ...connectorFormData };
    await postDsaMasterApiCall(newConnector, setConnectorFormData);
    handleClosePopover();
  };
  const openC = Boolean(anchorEl);
  const id = openC ? "connector-popover" : undefined;

  const { monthIdData, loadingBId, fetchData } = useBusinessMonthYear();
  const [businessMonthID, setBusinessMonthID] = useState();
  const MInput = inputStyle();
  const handleReset = () => {
    setIsForwarded(false);
    setSelectedGroup("");
    setSelectedManager("");
    setSelectedDSA("");
    setSelectedSubDSA(-1);
    setSelectedLoanType("");
    setSelectedAppliedTo("");
    setCustomerName("");
    setProviderPayout("");
    setDSAPayout("");
    setSelectedDsaSalesManager("");
    setApplicationNumber("");
    setLoanAmount("");
    setRemarks("");
    setSubDsaPayout(0);
    setEditStatus(false);
    setDate(new Date().toISOString().slice(0, 10)); // Reset to current date if needed
    setLoginDate(new Date().toISOString().slice(0, 10));
    setEntryId("");
    setGrossPayoutAmount(0);
    setDsaPayoutAmount(0);
    setDsaStatus(false);
    setBusinessStatus("N");
    setEntryCondition("N");
    setDsaTdsPercent("");
    setSubDsaTdsPercent("");
    setDisbursedAmount("");
    setLoginDate(new Date().toISOString().slice(0, 10));
    setActualDsaPayout("");
    setDisbursedState(false);
    setServiceTypeCode("");
    setDisbursements([]);
    setPayouts({
      providerPayoutAmount: 0,
      tdsOnProviderPayout: 0,
      finalProviderPayoutAmount: 0,
      dsaPayoutAmountD: 0,
      tdsOnDsaPayout: 0,
      finalDsaPayoutAmount: 0,
      connectorPayout: 0,
      tdsOnConnectorPayout: 0,
      finalConnectorPayoutAmount: 0,
    });
  };
  const inputStatus = false;
  const {
    businessMasterData,
    providerData,
    dsaData,
    entryData,
    subDsaData,
    managersData,
    dsaManagersData,
    message,
    alertType,
    open,
    editStatus,
    loading,
    finalFinanceData,
    setLoading,
    setEditStatus,
    companyConfig,
    fetchEntriesFeildsData,
    fetchEntriesByTypeCode,
    postDsaMasterApiCall,
    fetchFilteredFinanceDetails,
    fetchBusinessEntriesApiCall,
    fetchFinanceDetails,
    postEntry,
    putEntry,
    deleteEntry,
    setAlert,
    handleClose,
  } = useBusinessEntryApiCall("BL", handleReset);

  const options = [
    { dsaId: user.companyId || "", dsaName: "Own Business", dsaCode: "" },
    ...(Array.isArray(dsaData) ? dsaData : []),
  ];
  const filteredDsaMngrFunction = useCallback(() => {
    const defaultManager = {
      firstName: "No",
      lastName: "Manager",
      employeeId: 0,
    };
    if (selectedSubDSA) {
      return [
        defaultManager,
        ...dsaManagersData.filter((item) => item.companyId === selectedSubDSA),
      ];
    }
    return [defaultManager];
  }, [selectedSubDSA, dsaManagersData]);
  useEffect(() => {
    if (selectedLoanType) {
      fetchFinanceDetails(selectedLoanType);
    }
  }, [selectedLoanType]);
  useEffect(() => {
    if (selectedDSA) {
      const selectedDsa = dsaData.find((dsa) => dsa.dsaId === parseInt(selectedDSA));
      if (selectedDsa) {
        setDsaStatus(selectedDsa.dsaStatus == "S");
      } else {
        setDsaStatus(false); // Reset if no DSA is found
        setSelectedDsaSalesManager(0);
        setDSAPayout(0);
        setSubDsaId(0);
      }
    } else {
      setDsaStatus(false); // Reset if no DSA is selected
    }
  }, [selectedDSA]);
  useEffect(() => {
    const filteredData = filteredDsaMngrFunction();
    setFilteredSubDsaManagers(filteredData); // Update filtered managers state
  }, [filteredDsaMngrFunction, selectedSubDSA]);
  useEffect(() => {
    if (!editStatus && finalFinanceData.length > 0) {
      const selectedFinance = finalFinanceData.find(
        (eachEntry) => eachEntry.finananceId == selectedAppliedTo
      );

      if (selectedFinance) {
        setProviderPayout(selectedFinance.grossPayOut);
        setActualDsaPayout(selectedFinance.dsaPayOut);
        calculateMarginal(selectedFinance.grossPayOut, selectedFinance.dsaPayOut);
      }
    }
  }, [selectedAppliedTo, finalFinanceData, editStatus]);
  useEffect(() => {
    if (!dsaStatus) {
      setSelectedSubDSA("");
      setSelectedDsaSalesManager(0);
      setSubDsaPayout();
    }
  }, [dsaStatus]);
  useEffect(() => {
    if (companyConfig) {
      setSubDsaTdsPercent(companyConfig.companyTDSPercent);
      setDsaTdsPercent(companyConfig.companyTDSPercent);
    }
  }, [companyConfig]);
  useEffect(() => {
    if (LoanAmount && providerPayout) {
      calculatePayouts();
    }
  }, [LoanAmount, providerPayout, dsaPayout, subDsaPayout]);
  useEffect(() => {
    if (activeTab === 0 && monthIdData) {
      setBusinessMonthID(monthIdData[0]?.businessMonthID || "");
      fetchBusinessEntriesApiCall(fromDate, toDate);
    }
  }, [activeTab, monthIdData]);
  const handleGetData = () => {
    fetchBusinessEntriesApiCall(fromDate, toDate);
  };
  const handleFilter = useCallback(() => {
    fetchFilteredFinanceDetails(serviceTypeCode, businessStatusFilter, businessMonthID);
  }, [businessStatusFilter, businessMonthID]);
  const calculatePayouts = () => {
    const roundToTwoDecimals = (value) => Math.round(value * 100) / 100;
    const providerPayoutAmount = roundToTwoDecimals((LoanAmount * providerPayout) / 100);
    const tdsOnProviderPayout = roundToTwoDecimals(
      (providerPayoutAmount * companyConfig.companyTDSPercent) / 100
    );
    const finalProviderPayoutAmount = roundToTwoDecimals(
      providerPayoutAmount - tdsOnProviderPayout
    );

    const dsaPayoutAmountD = roundToTwoDecimals((LoanAmount * actualDsaPayout) / 100);
    const tdsOnDsaPayout = roundToTwoDecimals(
      (dsaPayoutAmountD * companyConfig.companyTDSPercent) / 100
    );
    const finalDsaPayoutAmount = roundToTwoDecimals(dsaPayoutAmountD - tdsOnDsaPayout);
    const connectorPayout = roundToTwoDecimals((LoanAmount * subDsaPayout) / 100);
    const tdsOnConnectorPayout = roundToTwoDecimals(
      (connectorPayout * companyConfig.companyTDSPercent) / 100
    );
    const finalConnectorPayoutAmount = roundToTwoDecimals(connectorPayout - tdsOnConnectorPayout);
    const data = {
      providerPayoutAmount,
      tdsOnProviderPayout,
      finalProviderPayoutAmount,
      dsaPayoutAmountD,
      tdsOnDsaPayout,
      finalDsaPayoutAmount,
      connectorPayout,
      tdsOnConnectorPayout,
      finalConnectorPayoutAmount,
    };
    setPayouts({
      providerPayoutAmount,
      tdsOnProviderPayout,
      finalProviderPayoutAmount,
      dsaPayoutAmountD,
      tdsOnDsaPayout,
      finalDsaPayoutAmount,
      connectorPayout,
      tdsOnConnectorPayout,
      finalConnectorPayoutAmount,
    });
    return data;
  };
  const postLoanEntryApiCall = () => {
    const payouts = calculatePayouts();
    const data = {
      entryId: 0,
      assignedcompanyID: assignedTo,
      dsaId: parseInt(user.companyId),
      subDsaId: parseInt(selectedSubDSA),
      applicationNumber: applicationNumber,
      businessType: productType,
      date: date,
      businessMonthId: parseInt(businessMonthId),
      employeeId: parseInt(selectedManager),
      dsaEmployeeId: user.employeeId,
      businessId: parseInt(selectedLoanType),
      customerName: customerName,
      finananceId: parseInt(selectedAppliedTo),
      appliedAmount: parseFloat(parseFloat(LoanAmount).toFixed(2)),
      businessStatus: disbursedState ? 4 : 0,
      loginDate: loginDate,
      businessEntriesMIS: {
        grossPayoutPercent: parseFloat(parseFloat(providerPayout).toFixed(2)),
        grossPayoutAmount: parseFloat(parseFloat(payouts.providerPayoutAmount).toFixed(2)),
        remarks: remarks,
        dsamargin: parseFloat(parseFloat(dsaPayout).toFixed(2)),
        dsapayoutAmount: parseFloat(parseFloat(payouts.dsaPayoutAmountD).toFixed(2)),
        misstatus: disbursedState ? "C" : "N",
        subDSAPaymentAmount: parseFloat(parseFloat(payouts.connectorPayout).toFixed(2)),
        subDSAPayoutPercent: parseFloat(parseFloat(subDsaPayout || 0).toFixed(2)),
        dsapayoutPercent: parseFloat(parseFloat(actualDsaPayout || 0).toFixed(2)),
      },
    };

    postEntry(data, setActiveTab);
  };
  const putLoanEntryApiCall = (entryStatus) => {
    const payouts = calculatePayouts();
    const data = {
      ...selectedEntryData,
      entryId: parseInt(entryId),
      assignedcompanyID: assignedTo,
      dsaId: parseInt(user.companyId),
      subDsaId: parseInt(selectedSubDSA),
      applicationNumber: applicationNumber,
      businessType: productType,
      date: date,
      loginDate: loginDate,
      employeeId: parseInt(selectedManager),
      businessId: parseInt(selectedLoanType),
      customerName: customerName,
      finananceId: parseInt(selectedAppliedTo),
      appliedAmount: parseFloat(parseFloat(LoanAmount).toFixed(2)),
      loginDate: loginDate,
      businessEntriesMIS: {
        grossPayoutPercent: parseFloat(parseFloat(providerPayout).toFixed(2)),
        grossPayoutAmount: parseFloat(parseFloat(payouts.providerPayoutAmount).toFixed(2)),
        subDSAPaymentAmount: parseFloat(parseFloat(payouts.connectorPayout).toFixed(2)),
        dsapayoutPercent: parseFloat(parseFloat(actualDsaPayout || 0).toFixed(2)),
        subDSAPayoutPercent: parseFloat(parseFloat(subDsaPayout || 0).toFixed(2)),
        dsamargin: parseFloat(parseFloat(dsaPayout).toFixed(2)),
        remarks: remarks,
        misstatus: disbursedState ? "C" : selectedEntryData.businessEntriesMIS.misstatus,
        dsapayoutAmount: parseFloat(parseFloat(payouts.dsaPayoutAmountD).toFixed(2)),
        misamount: parseFloat(parseFloat(LoanAmount).toFixed(2)),
      },
    };
    putEntry(entryId, data, setActiveTab);
  };
  const deleteLoanEntryApiCall = (lEntryId) => {
    deleteEntry(lEntryId);
  };
  const handleEditLoanRow = (rowData) => {
    fetchBusinessDisbursementsByentryId(rowData.entryId);
    setActiveTab(1);
    setSelectedEntryData(rowData);
    setEditStatus(true);
    setIsForwarded(rowData.assignedcompanyID === 0);
    setApplicationNumber(rowData.applicationNumber);
    setLoanAmount(rowData.appliedAmount);
    setSelectedLoanType(rowData.businessId);
    setCustomerName(rowData.customerName);
    setDate(formatTimestampToDate(rowData.date));
    setLoginDate(formatTimestampToDate(rowData.loginDate));
    setSelectedDSA(rowData.dsaId);
    setSelectedManager(rowData.employeeId);
    setSelectedDsaSalesManager(rowData.dsaEmployeeId || 0);
    setEntryId(rowData.entryId);
    setProductType(rowData.businessType);
    setSelectedAppliedTo(rowData.finananceId);
    setProviderPayout(rowData.businessEntriesMIS.grossPayoutPercent);
    setRemarks(rowData.businessEntriesMIS.remarks);
    setSelectedSubDSA(rowData.subDsaId);
    setSubDsaPayout(rowData.businessEntriesMIS.subDSAPayoutPercent);
    setEntryCondition(rowData.businessEntriesMIS.misstatus);
    setSelectedGroup("1");
    setBusinessStatus(rowData.businessStatus);
    setBusinessMonthId(rowData.businessMonthId);
    setBusinessMonthID(rowData.businessMonthId);
    setSubDsaTdsPercent(rowData.subDsaTdsPercent);
    setDsaTdsPercent(rowData.dsaTdsPercent);
    setDisbursedAmount(rowData.disbursedAmount);
    setActualDsaPayout(rowData.businessEntriesMIS.dsapayoutPercent);
    setDSAPayout(rowData.businessEntriesMIS.dsamargin);
    setServiceTypeCode(rowData.businessType);
    setAssignedTo(rowData.assignedcompanyID);
  };
  const calculateMarginal = (provider, dsa) => {
    const providerValue = parseFloat(provider) || 0;
    const dsaValue = parseFloat(dsa) || 0;

    if (providerValue > 0) {
      const marginal = Math.round((dsaValue / providerValue) * 100 * 100) / 100; // Numeric rounding to 2 decimals
      setDSAPayout(marginal);
    } else {
      setDSAPayout(0); // Default to 0 if provider value is zero
    }
  };
  const handleSave = (e) => {
    e.preventDefault();
    if (editStatus) {
      putLoanEntryApiCall();
    } else {
      postLoanEntryApiCall();
    }
  };
  const handleToggle = (event) => {
    const checked = event.target.checked;
    setIsForwarded(checked);
  };
  const resetFormState = () => {
    handleReset();
    setEditStatus(false);
  };
  function formatTimestampToDate(timestamp) {
    const date = new Date(timestamp); // Convert timestamp to Date object
    return date.toISOString().slice(0, 10); // Format it as "YYYY-MM-DD"
  }
  function openDailogDeleteBox(fEntryId) {
    setOpenDialog(true);
    SetServiceEntryId(fEntryId);
  }
  function handleConfirmDelete() {
    deleteLoanEntryApiCall(serviceEntryId); // Only delete if entryId exists
    setTimeout(() => {
      setOpenDialog(false);
    }, 1000);
  }
  const businessStatusMap = {
    0: "New",
    1: "In Progress",
    2: "MIS Sent",
    3: "Partially Disbursed",
    4: "Disbursed",
    21: "Aborted",
  };
  const ActionCellRenderer = (props) => {
    const rowIndex = props.node.rowIndex;
    let rowData = null;

    if (props.api && props.api.getDisplayedRowAtIndex(rowIndex)) {
      rowData = props.api.getDisplayedRowAtIndex(rowIndex).data;
    } else {
      console.error("API or row data is not available.");
    }

    const handleEditClick = () => {
      if (rowData) {
        handleEditLoanRow(rowData);
      }
    };

    const handleDeleteClick = () => {
      if (rowData && rowData.entryId) {
        openDailogDeleteBox(rowData.entryId);
      } else {
        console.warn("Row data or entry ID is not available for deletion.");
      }
    };

    return (
      <div>
        <ViewButton type="button" onClick={handleEditClick}>
          <EditIcon />
        </ViewButton>
        <DeleteButton type="button" onClick={() => handleDeleteClick()}>
          <DeleteIcon />
        </DeleteButton>
      </div>
    );
  };
  const columns = [
    {
      headerName: "Date",
      field: "date",
      filter: true,
      sorted: true,
      minWidth: 90,
      valueFormatter: (params) => {
        const date = new Date(params.value); // Convert the timestamp to a Date object
        const day = date.getDate().toString().padStart(2, "0"); // Get day with leading zero
        const month = date.toLocaleString("default", { month: "short" }); // Get month as short name
        const year = date.getFullYear(); // Get full year
        return `${day}-${month}-${year}`; // Return in "dd-MMM-yyyy" format
      },
      sort: "desc",
    },
    {
      headerName: "Appl. No.",
      field: "applicationNumber",
      filter: true,
      sorted: true,
      minWidth: 70,
      flex: 1,
    },
    {
      headerName: "customer Name",
      field: "customerName",
      filter: true,
      sorted: true,
      minWidth: 70,
      flex: 1,
    },
    {
      headerName: "Loan Amount",
      field: "appliedAmount",
      filter: true,
      sortable: true,
      minWidth: 100,
      flex: 1.1,
      cellStyle: { textAlign: "right", fontWeight: "500" }, // Aligns the text to the right
      valueFormatter: (params) =>
        `₹ ${params.value.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
    },
    {
      headerName: "Revenue (%)",
      field: "businessEntriesMIS.grossPayoutPercent", // This won't work directly for nested objects
      valueGetter: (params) => params.data?.businessEntriesMIS?.grossPayoutPercent ?? "",
      filter: true,
      sortable: true,
      editable: true,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
    },
    {
      headerName: "DSA Payout (%)",
      field: "businessEntriesMIS.dsaPayoutPercent", // Use valueGetter for nested fields
      valueGetter: (params) => params.data?.businessEntriesMIS?.dsapayoutPercent ?? "",
      filter: true,
      sortable: true,
      editable: true,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
    },

    {
      headerName: "Business Status",
      field: "businessStatus", // Original field from the backend
      valueGetter: (params) => businessStatusMap[params.data?.businessStatus] ?? "Unknown", // Map digit to string
      filter: true,
      sortable: true,
      editable: false,
      flex: 1,
      cellStyle: { textAlign: "center", fontWeight: "500" },
      filterParams: {
        valueFormatter: (params) => businessStatusMap[params.value] ?? params.value, // Show string options in filter
        textFormatter: (value) => value?.toLowerCase(), // Ensure case-insensitive search
      },
    },

    { headerName: "Actions", cellRenderer: ActionCellRenderer, width: 120 },
  ];
  const handleCheckboxChange = (e) => {
    setConnectorFormData({
      ...connectorFormData,
      hasGST: e.target.checked,
      gstNumber: e.target.checked ? connectorFormData.gstNumber : "", // Reset GST if unchecked
    });
  };
  const handleAbortClick = () => {
    if (Number(businessStatus) === 21) {
      setUnAbortBox(true);
      setOpenDailogAbortBox(true);
      return;
    }

    setOpenDailogAbortBox(true);
  };
  const constructAbortUrl = () => {
    let disburseId =
      disbursements.length === 0 && selectedDisbursement === null ? 0 : selectedDisbursement;
    return `${URLs.dibursementAbort}?entryId=${entryId}&disburseId=${disburseId}`;
  };
  const handleConfirmAbort = async () => {
    if (!selectedDisbursement) {
      alert("Please select a disbursement entry first.");
      return;
    }

    if (Number(businessStatus) === 21) {
      try {
        const url = URLs.resumeEntry;
        const options = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt_token}`,
          },
          body: JSON.stringify([entryId]),
        };

        const response = await fetch(url, options);

        if (response.ok) {
          setAlert("Application Resumed Successfully", "success");
          setActiveTab(0);
        } else {
          const errorText = await response.text();
          throw new Error(errorText || "Failed to Resume Application");
        }
      } catch (error) {
        setAlert(error.message || "An error occurred while resuming application", "error");
      } finally {
        setOpenDailogAbortBox(false);
      }
    } else {
      try {
        const url = constructAbortUrl();
        const options = {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt_token}`,
          },
        };

        const response = await fetch(url, options);

        if (response.ok) {
          setAlert("Aborted Successfully", "success");
          setActiveTab(0);
          setSelectedDisbursement(null);
        } else {
          const errorText = await response.text();
          throw new Error(errorText || "Failed to abort");
        }
      } catch (error) {
        setAlert(error.message || "An error occurred while aborting", "error");
      } finally {
        setOpenDailogAbortBox(false);
      }
    }
  };

  useEffect(() => {
    if (openDailogAbortBox && disbursements) {
      const defaultDisbursement = disbursements.find((disb) => disb.disbursementStatus === "D");
      if (defaultDisbursement) {
        setSelectedDisbursement(defaultDisbursement.disburseId);
      } else {
        setSelectedDisbursement(null); // Reset if no "D" status found
      }
    }
  }, [openDailogAbortBox, disbursements, setSelectedDisbursement]);
  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  const tabs = [{ label: "Entries" }, { label: "Entry Form" }];
  const fetchBusinessDisbursementsByentryId = async (entryId) => {
    const url = `${URLs.bussinessDisbursement}/${entryId}`;
    setLoading(true);
    try {
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`, // Include the JWT token here
        },
      };
      const response = await fetch(url, options);
      if (!response.ok) {
        throw new Error("Failed to fetch Disbursement details");
      }
      const data = await response.json();
      setDisbursements(data);
    } catch (error) {
      setDisbursements([]);
      setAlert("It is not disbursed yet", "success");
    }
    setLoading(false);
  };
  return (
    <DashboardLayout>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          borderRadius: "12px",
          overflow: "auto",
          flexGrow: 1,
          boxShadow: "none",
          border: "none",
          height: "100%",
          pt: 2,
          backgroundColor: "transparent",
        }}
      >
        <Dialog
          open={loading}
          onClose={() => setLoading(false)}
          aria-labelledby="loading-dialog-title"
        >
          <DialogContent style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <CircularProgress color="primary" />
            <Typography variant="h6" style={{ marginTop: "20px" }}>
              Loading, please wait...
            </Typography>
          </DialogContent>
        </Dialog>
        <Dialog open={openDialog}>
          <DialogContent sx={subDialogContentStyle}>
            <DialogContentText sx={dialogContentTextStyle}>
              {`Are you sure you want to delete`}
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={entryStyles.dialogActions}>
            <StyledButton onClick={handleConfirmDelete}>Yes</StyledButton>
            <StyledButton onClick={() => setOpenDialog(false)} variant="outlined">
              No
            </StyledButton>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openDailogAbortBox}
          sx={{
            "& .MuiDialog-paper": {
              backgroundColor: "#1C2526",
              borderRadius: "12px",
              padding: "16px",
              minWidth: "400px",
              maxWidth: "500px",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.3)",
            },
          }}
        >
          <DialogContent sx={{ padding: "24px", color: "#FFFFFF", backgroundColor: "#1C2526" }}>
            <DialogContentText
              sx={{
                color: "#FFFFFF",
                fontWeight: 500,
                fontSize: "1.1rem",
                marginBottom: "16px",
                textAlign: "center",
              }}
            >
              {unAbortbox
                ? `Are you sure you want to Initiate application number ${applicationNumber} for ${customerName}?`
                : `Are you sure you want to abort application number ${applicationNumber} for ${customerName}?`}
            </DialogContentText>

            {/* Disbursements List */}
            <RadioGroup
              value={selectedDisbursement}
              onChange={(e) => setSelectedDisbursement(Number(e.target.value))}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                padding: "12px",
                background: "linear-gradient(180deg, #2A3436 0%, #1C2526 100%)", // Subtle gradient for modern touch
                borderRadius: "8px",
                border: "1px solid #FF8C0033", // Faint orange border
                marginBottom: "16px",
                transition: "all 0.3s ease",
              }}
            >
              {disbursements.map((disb) => (
                <FormControlLabel
                  key={disb.disburseId}
                  value={disb.disburseId}
                  control={
                    <Radio
                      sx={{
                        color: "#FF8C00",
                        "&.Mui-checked": { color: "#FF8C00" },
                        "& .MuiSvgIcon-root": {
                          fontSize: "1.2rem",
                          backgroundColor: "#1C2526",
                          borderRadius: "50%",
                          padding: "2px",
                          boxShadow: "0 0 8px rgba(255, 140, 0, 0.3)", // Subtle orange glow
                        },
                      }}
                    />
                  }
                  label={
                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                      <Typography variant="body2" sx={{ color: "#FFFFFF", fontSize: "0.9rem" }}>
                        <strong style={{ color: "#FF8C00" }}>Disbursed:</strong> ₹
                        {disb.disbursedAmount.toLocaleString()}
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#FFFFFF", fontSize: "0.9rem" }}>
                        <strong style={{ color: "#FF8C00" }}>Gross Payout:</strong> ₹
                        {disb.grossPayoutAmount.toLocaleString()}
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#FFFFFF", fontSize: "0.9rem" }}>
                        <strong style={{ color: "#FF8C00" }}>Payout %:</strong>{" "}
                        {disb.grossPayoutPercent}%
                      </Typography>
                    </div>
                  }
                  sx={{
                    backgroundColor: "#1C2526",
                    border: "1px solid #FF8C0044", // Slightly transparent orange border
                    borderRadius: "6px",
                    padding: "8px 12px",
                    margin: "0",
                    transition: "all 0.2s ease-in-out",
                    "&:hover": {
                      backgroundColor: "#2A3436",
                      transform: "translateY(-2px)", // Subtle lift effect
                      boxShadow: "0 4px 12px rgba(255, 140, 0, 0.2)", // Orange shadow on hover
                    },
                  }}
                />
              ))}
            </RadioGroup>
          </DialogContent>

          <DialogActions
            sx={{
              padding: "16px",
              justifyContent: "space-between",
              borderTop: "1px solid #2A3436",
            }}
          >
            <StyledButton onClick={handleConfirmAbort} disabled={selectedDisbursement === null}>
              Yes
            </StyledButton>
            <StyledButton
              onClick={() => {
                setOpenDailogAbortBox(false);
                setSelectedDisbursement(null);
              }}
              variant="outlined"
            >
              No
            </StyledButton>
          </DialogActions>
        </Dialog>
        <StyledSnackbar
          open={open}
          autoHideDuration={5000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          severity={alertType}
        >
          <StyledAlert onClose={handleClose} severity={alertType}>
            {message}
          </StyledAlert>
        </StyledSnackbar>
        <ResponsiveTabs
          tabs={tabs}
          activeTab={activeTab}
          onChange={handleChange}
          labelColor="secondary"
          bgColor="#e0f7fa"
        />
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            mt: 1,
            pt: 1,
            backgroundColor: "transparent",
            boxShadow: "none",
            border: "none",
          }}
        >
          {activeTab === 0 && (
            <Box
              sx={{
                overflowX: "auto",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1, mr: 1 }}>
                <Grid container spacing={2} pt={0.7} alignItems="center">
                  <Grid item xs={12} sm={4} md={3} lg={2}>
                    <TextField
                      fullWidth
                      type="date"
                      label="From Date"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      sx={MInput.b}
                      InputLabelProps={{
                        shrink: true,
                        sx: {
                          color: MInput.a,
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} lg={2}>
                    <TextField
                      fullWidth
                      type="date"
                      label="To Date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      sx={MInput.b}
                      InputLabelProps={{
                        shrink: true,
                        sx: {
                          color: MInput.a,
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} lg={2}>
                    <StyledButton onClick={handleGetData}>Get Data</StyledButton>
                  </Grid>
                </Grid>
                <FilterSection
                  businessStatusFilter={businessStatusFilter}
                  setBusinessStatusFilter={setBusinessStatusFilter}
                  monthIdData={monthIdData}
                  businessMonthID={businessMonthID}
                  setBusinessMonthID={setBusinessMonthID}
                  serviceTypeCode={serviceTypeCode}
                  setServiceTypeCode={setServiceTypeCode}
                  handleFilter={handleFilter}
                />
              </Box>
              <StyledAgGridContainer
                component={Paper}
                className="ag-theme-alpine"
                sx={{
                  flexGrow: 1,
                  backgroundColor: "transparent",
                  boxShadow: "none",
                  border: "none",
                }}
              >
                <AgGridReact
                  rowData={entryData}
                  columnDefs={columns}
                  pagination
                  paginationPageSize={11}
                />
              </StyledAgGridContainer>
            </Box>
          )}
          {activeTab === 1 && (
            <Grid container spacing={1}>
              <Grid item xs={12} md={12} lg={7}>
                <Box
                  sx={{
                    height: "100%",
                    backgroundColor: "#FFFFFF",
                    borderRadius: "15px",
                    padding: 2,
                  }}
                >
                  <div style={{ ...entryStyles.divStyle }}>
                    <StyledTypography>
                      {!editStatus ? "Entry Form" : "Edit Entry Details"}
                    </StyledTypography>
                    {editStatus && (
                      <>
                        <Tooltip title="Reset">
                          <StyledButtonC onClick={resetFormState}>
                            <RestartAltIcon />
                          </StyledButtonC>
                        </Tooltip>
                        <Tooltip title="">
                          <StyledButtonAbort onClick={handleAbortClick}>
                            {Number(businessStatus) === 21 ? "Resume" : "Abort"}
                          </StyledButtonAbort>
                        </Tooltip>
                      </>
                    )}
                  </div>
                  <form onSubmit={handleSave} autoComplete="off">
                    <Box p={{ sm: 1, md: 2 }} pt={{ xs: 3, sm: 2 }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={6} xl={3}>
                          <TextField
                            label="Business Date"
                            type="date"
                            fullWidth
                            required
                            value={date || new Date().toISOString().split("T")[0]} // Set default value to today's date
                            onChange={(e) => setDate(e.target.value)}
                            InputProps={{
                              readOnly: inputStatus,
                            }}
                            sx={MInput.b}
                            InputLabelProps={{
                              shrink: true,
                              sx: {
                                color: MInput.a,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} xl={3}>
                          <TextField
                            label="Login Date"
                            type="date"
                            fullWidth
                            required
                            value={loginDate || new Date().toISOString().split("T")[0]} // Set default value to today's date
                            onChange={(e) => setLoginDate(e.target.value)}
                            InputProps={{
                              readOnly: inputStatus,
                            }}
                            sx={MInput.b}
                            InputLabelProps={{
                              shrink: true,
                              sx: {
                                color: MInput.a,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            label="Customer Name"
                            fullWidth
                            required
                            value={customerName}
                            onChange={(e) => setCustomerName(e.target.value)}
                            InputProps={{ readOnly: inputStatus }}
                            sx={MInput.b}
                            InputLabelProps={{
                              sx: {
                                color: MInput.a,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6} xl={4}>
                          <TextField
                            label="Application Number"
                            fullWidth
                            required
                            value={applicationNumber}
                            onChange={(e) => setApplicationNumber(e.target.value.trim())}
                            InputProps={{ readOnly: inputStatus }}
                            sx={MInput.b}
                            InputLabelProps={{
                              sx: {
                                color: MInput.a,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6} xl={4}>
                          <TextField
                            label="Applied Amount"
                            fullWidth
                            required
                            value={LoanAmount}
                            onChange={() => {}}
                            InputProps={{
                              readOnly: inputStatus,
                              inputComponent: CurrencyInput,
                              inputProps: {
                                value: LoanAmount,
                                decimalsLimit: 2,
                                prefix: "₹ ",
                                onValueChange: (value) => setLoanAmount(value),
                                intlConfig: { locale: "en-IN" }, // Indian number format
                              },
                            }}
                            sx={MInput.b}
                            InputLabelProps={{
                              sx: {
                                color: MInput.a,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6} xl={4}>
                          <Autocomplete
                            options={managersData}
                            getOptionLabel={(option) => option.firstName + " " + option.lastName}
                            value={
                              managersData.some((item) => item.employeeId === selectedManager)
                                ? managersData.find((item) => item.employeeId === selectedManager)
                                : null
                            }
                            onChange={(event, value) =>
                              setSelectedManager(value ? value.employeeId : "")
                            }
                            disableClearable={false}
                            filterOptions={(options, state) => {
                              const input = state.inputValue.toLowerCase();

                              // Separate options into those that start with the input and those that contain itlastName
                              const startsWithInput = options.filter((option) =>
                                (option.firstName + " " + option.lastName)
                                  .toLowerCase()
                                  .startsWith(input)
                              );

                              const containsInput = options.filter(
                                (option) =>
                                  !(option.firstName + " " + option.lastName)
                                    .toLowerCase()
                                    .startsWith(input) &&
                                  (option.firstName + " " + option.lastName)
                                    .toLowerCase()
                                    .includes(input)
                              );

                              // Combine the options with those starting with the input first, then the rest
                              return [...startsWithInput, ...containsInput];
                            }}
                            PaperComponent={CustomPaper}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Head Office Manager"
                                variant="outlined"
                                required
                                sx={{
                                  height: 43,
                                  ...MInput.b,
                                  "& .MuiInputBase-root": {
                                    height: "100%",
                                    minHeight: 43,
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    color: MInput.a, // Ensure this applies to the label
                                    "&.Mui-focused": {
                                      color: "red", // Focused label color
                                    },
                                  },
                                }}
                              />
                            )}
                            disabled={inputStatus}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Autocomplete
                            options={subDsaData}
                            getOptionLabel={(option) => option.dsaName}
                            value={
                              subDsaData.some((item) => item.dsaId === selectedSubDSA)
                                ? subDsaData.find((item) => item.dsaId === selectedSubDSA)
                                : null
                            }
                            onChange={(event, value) => setSelectedSubDSA(value ? value.dsaId : -1)}
                            disableClearable={false}
                            filterOptions={(options, state) => {
                              const input = state.inputValue.toLowerCase();
                              // Separate options into those that start with the input and those that contain it
                              const startsWithInput = options.filter((option) =>
                                option.dsaName.toLowerCase().startsWith(input)
                              );
                              const containsInput = options.filter(
                                (option) =>
                                  !option.dsaName.toLowerCase().startsWith(input) &&
                                  option.dsaName.toLowerCase().includes(input)
                              );
                              // Combine the options with those starting with the input first, then the rest
                              return [...startsWithInput, ...containsInput];
                            }}
                            PaperComponent={CustomPaper}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Connector"
                                variant="outlined"
                                sx={{
                                  height: 43,
                                  ...MInput.b,
                                  "& .MuiInputBase-root": {
                                    height: "100%",
                                    minHeight: 43,
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    color: MInput.a, // Ensure this applies to the label
                                    "&.Mui-focused": {
                                      color: "red", // Focused label color
                                    },
                                  },
                                }}
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {params.InputProps.endAdornment}
                                      <PersonAddIcon
                                        style={{ cursor: "pointer", marginLeft: 8 }}
                                        onClick={handleOpenPopover}
                                      />
                                    </>
                                  ),
                                }}
                              />
                            )}
                            disabled={inputStatus}
                          />
                          <Popover
                            id={id}
                            open={openC}
                            anchorEl={anchorEl}
                            onClose={handleClosePopover}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "left",
                            }}
                            PaperProps={{
                              sx: {
                                backgroundColor: "#ffffff", // Dark white background
                                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", // Optional shadow for better visibility
                                borderRadius: "8px", // Rounded corners for a modern look
                              },
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "left",
                            }}
                          >
                            <Box sx={{ p: 1, width: "15vw", maxwidth: 250, minWidth: 150 }}>
                              <StyledTypographyA>Add Connector</StyledTypographyA>
                              <TextField
                                name="connectorId"
                                label="Connector ID"
                                value={connectorFormData.connectorId}
                                onChange={handleConnectorChange}
                                fullWidth
                                margin="dense"
                                sx={MInput.b}
                                InputLabelProps={{
                                  sx: {
                                    color: MInput.a,
                                  },
                                }}
                              />
                              <TextField
                                name="connectorName"
                                label="Connector Name"
                                value={connectorFormData.connectorName}
                                onChange={handleConnectorChange}
                                fullWidth
                                margin="dense"
                                sx={MInput.b}
                                InputLabelProps={{
                                  sx: {
                                    color: MInput.a,
                                  },
                                }}
                              />
                              <TextField
                                name="panNumber"
                                label="PAN Number"
                                value={connectorFormData.panNumber}
                                onChange={handleConnectorChange}
                                fullWidth
                                margin="dense"
                                sx={MInput.b}
                                InputProps={{ inputProps: { maxLength: 10 } }} // PAN is 10 characters
                                InputLabelProps={{
                                  sx: {
                                    color: MInput.a,
                                  },
                                }}
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={connectorFormData.hasGST}
                                    onChange={handleCheckboxChange}
                                  />
                                }
                                label="Connector has GST"
                              />

                              {/* Conditional GST Number Entry Field */}
                              {connectorFormData.hasGST && (
                                <TextField
                                  name="gstNumber"
                                  label="GST Number"
                                  value={connectorFormData.gstNumber}
                                  onChange={handleConnectorChange}
                                  fullWidth
                                  margin="dense"
                                  sx={MInput.b}
                                  InputProps={{ inputProps: { maxLength: 15 } }} // GST is 15 characters
                                  InputLabelProps={{
                                    sx: {
                                      color: MInput.a,
                                    },
                                  }}
                                />
                              )}

                              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
                                <StyledButtonAnchor
                                  onClick={handleClosePopover}
                                  sx={{
                                    backgroundColor: "#ffffff",
                                    border: `1px solid red`,
                                    color: "red",
                                  }}
                                >
                                  close
                                </StyledButtonAnchor>
                                <StyledButtonAnchor
                                  onClick={handleConnectorSave}
                                  variant="contained"
                                  color="primary"
                                  sx={{ ml: 2 }}
                                  disabled={disbursements.length > 0}
                                >
                                  Save
                                </StyledButtonAnchor>
                              </Box>
                            </Box>
                          </Popover>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Autocomplete
                            options={businessMasterData}
                            getOptionLabel={(option) => option.businessName}
                            value={
                              businessMasterData.some(
                                (item) => item.businessID === selectedLoanType
                              )
                                ? businessMasterData.find(
                                    (item) => item.businessID === selectedLoanType
                                  )
                                : null
                            }
                            onChange={(event, value) => {
                              setProductType(value ? value.type : "");
                              setSelectedLoanType(value ? value.businessID : "");
                            }}
                            disableClearable={false}
                            filterOptions={(options, state) => {
                              const input = state.inputValue.toLowerCase();
                              // Separate the options into those that start with the input and those that contain it
                              const startsWithInput = options.filter((option) =>
                                option.businessName.toLowerCase().startsWith(input)
                              );
                              const containsInput = options.filter(
                                (option) =>
                                  !option.businessName.toLowerCase().startsWith(input) &&
                                  option.businessName.toLowerCase().includes(input)
                              );
                              // Combine the options with those starting with the input first, then the rest
                              return [...startsWithInput, ...containsInput];
                            }}
                            PaperComponent={CustomPaper}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Business Type"
                                variant="outlined"
                                required
                                sx={{
                                  height: 43,
                                  ...MInput.b,
                                  "& .MuiInputBase-root": {
                                    height: "100%",
                                    minHeight: 43,
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    color: MInput.a, // Ensure this applies to the label
                                    "&.Mui-focused": {
                                      color: "red", // Focused label color
                                    },
                                  },
                                }}
                              />
                            )}
                            disabled={inputStatus}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Autocomplete
                            options={finalFinanceData}
                            getOptionLabel={(option) => option.finainacialInstitutionName}
                            value={
                              finalFinanceData.some(
                                (item) => item.finananceId === selectedAppliedTo
                              )
                                ? finalFinanceData.find(
                                    (item) => item.finananceId === selectedAppliedTo
                                  )
                                : null
                            }
                            onChange={(event, value) =>
                              setSelectedAppliedTo(value ? value.finananceId : "")
                            }
                            disableClearable={false}
                            filterOptions={(options, state) => {
                              const input = state.inputValue.toLowerCase();

                              // Filter options that start with the input value
                              const startsWithInput = options.filter((option) =>
                                option.finainacialInstitutionName.toLowerCase().startsWith(input)
                              );

                              // Filter options that contain the input value but do not start with it
                              const containsInput = options.filter(
                                (option) =>
                                  !option.finainacialInstitutionName
                                    .toLowerCase()
                                    .startsWith(input) &&
                                  option.finainacialInstitutionName.toLowerCase().includes(input)
                              );

                              // Combine the options: ones that start with the input first, then the rest
                              return [...startsWithInput, ...containsInput];
                            }}
                            PaperComponent={CustomPaper}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Provider Name"
                                variant="outlined"
                                required
                                sx={{
                                  height: 43,
                                  ...MInput.b,
                                  "& .MuiInputBase-root": {
                                    height: "100%",
                                    minHeight: 43,
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    color: MInput.a, // Ensure this applies to the label
                                    "&.Mui-focused": {
                                      color: "red", // Focused label color
                                    },
                                  },
                                }}
                              />
                            )}
                            disabled={inputStatus}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <TextField
                            label="Provider Payout %"
                            type="number" // Use "text" to handle custom validation for the format
                            fullWidth
                            required
                            value={providerPayout}
                            onChange={(e) => {
                              const value = e.target.value;
                              // Regex to match the format X.yyyy where X < 9 and yyyy can be 1-3 digits
                              if (/^\d{0,2}(\.\d{0,3})?$/.test(value)) {
                                setProviderPayout(value);
                                calculateMarginal(value, actualDsaPayout);
                              }
                            }}
                            inputProps={{
                              maxLength: 5,
                              readOnly: inputStatus,
                            }} // Limit the total length to 5 characters
                            placeholder="0.000" // Example format
                            sx={MInput.b}
                            InputLabelProps={{
                              sx: {
                                color: MInput.a,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <TextField
                            label="DSA Payout %"
                            type="number" // Use "text" to handle custom validation for the format
                            fullWidth
                            required
                            value={actualDsaPayout}
                            onChange={(e) => {
                              const value = e.target.value;
                              // Regex to match the format X.yyyy where X < 9 and yyyy can be 1-3 digits
                              if (/^\d{0,2}(\.\d{0,3})?$/.test(value)) {
                                setActualDsaPayout(value);
                                calculateMarginal(providerPayout, value);
                              }
                            }}
                            inputProps={{
                              maxLength: 5,
                              readOnly: inputStatus,
                            }}
                            placeholder="0.000" // Example format
                            sx={MInput.b}
                            InputLabelProps={{
                              sx: {
                                color: MInput.a,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <TextField
                            label="Marginal %"
                            type="number" // Use "text" to handle custom validation for the format
                            fullWidth
                            required
                            value={dsaPayout}
                            onChange={(e) => {
                              const value = e.target.value;
                              // Regex to match the format X.yyyy where X < 9 and yyyy can be 1-3 digits
                              if (/^\d{0,2}(\.\d{0,3})?$/.test(value)) {
                                setDSAPayout(value);
                              }
                            }}
                            inputProps={{
                              maxLength: 5,
                              readOnly: inputStatus,
                            }}
                            placeholder="0.000" // Example format
                            sx={MInput.b}
                            InputLabelProps={{
                              sx: {
                                color: MInput.a,
                              },
                            }}
                          />
                        </Grid>
                        {selectedSubDSA > -1 && (
                          <Grid item xs={12} md={3}>
                            <TextField
                              label="Connector % in DSA Payout"
                              type="text" // Use "text" to handle custom validation for the format
                              fullWidth
                              required
                              value={subDsaPayout}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d{0,3}(\.\d{0,5})?$/.test(value)) {
                                  setSubDsaPayout(value);
                                }
                              }}
                              inputProps={{
                                maxLength: 9,
                                readOnly: inputStatus,
                              }}
                              // disabled={true}
                              placeholder="0.000" // Example format
                              sx={MInput.b}
                              InputLabelProps={{
                                sx: {
                                  color: MInput.a,
                                  paddingBottom: "5px",
                                },
                              }}
                            />
                          </Grid>
                        )}
                        <Grid item xs={12} md={3}>
                          <Autocomplete
                            options={options}
                            value={options.find((opt) => opt.dsaId === assignedTo) || null}
                            getOptionLabel={(option) =>
                              option.dsaId === -2
                                ? option.dsaName // Show just "Own Business"
                                : `${option.dsaName} (${option.dsaCode})`
                            }
                            onChange={(event, newValue) => {
                              setAssignedTo(newValue ? newValue.dsaId : null);
                            }}
                            PaperComponent={CustomPaper}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Forward To"
                                variant="outlined"
                                required
                                sx={{
                                  height: 43,
                                  ...MInput.b,
                                  "& .MuiInputBase-root": {
                                    height: "100%",
                                    minHeight: 43,
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    color: MInput.a, // Ensure this applies to the label
                                    "&.Mui-focused": {
                                      color: "red", // Focused label color
                                    },
                                  },
                                }}
                              />
                            )}
                            sx={{ width: "100%" }}
                          />
                        </Grid>
                        <Grid item xs={12} md={9}>
                          <TextField
                            label="Remarks"
                            fullWidth
                            multiline
                            rows={2}
                            value={remarks}
                            onChange={(e) => setRemarks(e.target.value)}
                            // InputProps={{ readOnly: inputStatus }}
                            sx={MInput.b}
                            InputLabelProps={{
                              sx: {
                                color: MInput.a,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                      <MDBox mt={3} mb={0} gap={1} display="flex" justifyContent="flex-end">
                        <StyledButton type="submit">Save</StyledButton>
                      </MDBox>
                    </Box>
                  </form>
                </Box>
              </Grid>
              <Grid item xs={12} md={12} lg={5}>
                <Box
                  sx={{
                    height: "100%",
                    padding: 0,
                  }}
                >
                  <TableContainer
                    component={Paper}
                    sx={{
                      width: "100%",
                      overflowX: "auto",
                      position: "relative",
                      "&:hover": {
                        "& ::-webkit-scrollbar": {
                          width: "6px",
                          height: "6px",
                          transition: "width 0.3s ease, height 0.3s ease",
                        },
                        "& ::-webkit-scrollbar-thumb": {
                          backgroundColor: "rgba(49, 64, 111, 0.7)", // Visible thumb on hover
                          borderRadius: "4px",
                        },
                        "& ::-webkit-scrollbar-track": {
                          backgroundColor: "#e0e0e0",
                        },
                      },
                      scrollbarWidth: "thin",
                    }}
                  >
                    {disbursements.length == 0 && (
                      <Table>
                        <TableBody>
                          <TableRow>
                            <CustomTableCell sx={{ border: 0 }} colSpan={3}>
                              <StyledTypography>
                                {LoanAmount && providerPayout && dsaPayout
                                  ? "Percentage Distribution Overview"
                                  : "Please enter the percentage distribution."}
                              </StyledTypography>
                            </CustomTableCell>
                          </TableRow>
                          <TableRow>
                            <CustomTableCell minWidth="100px" flexGrow={1} fontWeight="normal">
                              Banker Payout @ {Number(providerPayout).toFixed(2)} %
                            </CustomTableCell>
                            <CustomTableCell
                              minWidth="100px"
                              flexGrow={1}
                              fontWeight="normal"
                              align="right"
                            >
                              ₹{" "}
                              {`${(Number(payouts.providerPayoutAmount) || 0).toLocaleString(
                                "en-IN",
                                { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                              )}`}
                            </CustomTableCell>
                            <CustomTableCell
                              minWidth="100px"
                              flexGrow={1}
                              fontWeight="normal"
                            ></CustomTableCell>
                          </TableRow>

                          {/* TDS Deduction Row */}
                          <TableRow>
                            <CustomTableCell minWidth="100px" flexGrow={1} fontWeight="normal">
                              Less: TDS @ {companyConfig.companyTDSPercent} %
                            </CustomTableCell>
                            <CustomTableCell
                              minWidth="100px"
                              flexGrow={1}
                              fontWeight="normal"
                              align="right"
                            >
                              ₹{" "}
                              {`${(Number(payouts.tdsOnProviderPayout) || 0).toLocaleString(
                                "en-IN",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )}`}
                            </CustomTableCell>
                            <CustomTableCell
                              minWidth="100px"
                              flexGrow={1}
                              fontWeight="normal"
                            ></CustomTableCell>
                          </TableRow>

                          {/* Net Banker Payout */}
                          <TableRow sx={{ backgroundColor: "rgba(51, 51, 51, 0.67)" }}>
                            <CustomTableCell
                              sx={{ color: "#ffffff" }}
                              minWidth="100px"
                              colSpan={2}
                              flexGrow={1}
                              fontWeight="bold"
                            >
                              Net Banker Payout
                            </CustomTableCell>
                            <CustomTableCell
                              sx={{ color: "#ffffff" }}
                              minWidth="100px"
                              flexGrow={1}
                              fontWeight="bold"
                              align="right"
                            >
                              ₹{" "}
                              {`${(Number(payouts.finalProviderPayoutAmount) || 0).toLocaleString(
                                "en-IN",
                                { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                              )}`}
                            </CustomTableCell>
                          </TableRow>

                          {/* DSA Payout Row */}
                          <TableRow>
                            <CustomTableCell minWidth="100px" flexGrow={1} fontWeight="normal">
                              DSA Payout @ {Number(actualDsaPayout).toFixed(2)} %
                            </CustomTableCell>
                            <CustomTableCell
                              minWidth="100px"
                              flexGrow={1}
                              fontWeight="normal"
                              align="right"
                            >
                              ₹{" "}
                              {`${(Number(payouts.dsaPayoutAmountD) || 0).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}`}
                            </CustomTableCell>
                            <CustomTableCell
                              minWidth="100px"
                              flexGrow={1}
                              fontWeight="normal"
                            ></CustomTableCell>
                          </TableRow>
                          <TableRow
                            sx={{
                              height: "30px", // Set a smaller height
                            }}
                          >
                            <CustomTableCell minWidth="100px" flexGrow={1} fontWeight="normal">
                              Less : TDS @ {companyConfig.companyTDSPercent} %
                            </CustomTableCell>
                            <CustomTableCell
                              minWidth="100px"
                              flexGrow={1}
                              fontWeight="normal"
                              align="right"
                            >
                              ₹
                              {` ${(Number(payouts.tdsOnDsaPayout) || 0).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}`}
                            </CustomTableCell>
                            <CustomTableCell
                              minWidth="100px"
                              flexGrow={1}
                              fontWeight="normal"
                            ></CustomTableCell>
                          </TableRow>
                          {/* Net DSA Payout */}
                          <TableRow sx={{ backgroundColor: "rgba(51, 51, 51, 0.67)" }}>
                            <CustomTableCell
                              sx={{ color: "#ffffff" }}
                              minWidth="100px"
                              colSpan={2}
                              flexGrow={1}
                              fontWeight="bold"
                            >
                              Net DSA Payout
                            </CustomTableCell>
                            <CustomTableCell
                              sx={{ color: "#ffffff" }}
                              minWidth="100px"
                              flexGrow={1}
                              fontWeight="bold"
                              align="right"
                            >
                              ₹{" "}
                              {`${(Number(payouts.finalDsaPayoutAmount) || 0).toLocaleString(
                                "en-IN",
                                { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                              )}`}
                            </CustomTableCell>
                          </TableRow>

                          {/* Connector Payout Row */}
                          <TableRow>
                            <CustomTableCell minWidth="100px" flexGrow={1} fontWeight="normal">
                              Connector Payout @ {Number(subDsaPayout).toFixed(2)} %
                            </CustomTableCell>
                            <CustomTableCell
                              minWidth="100px"
                              flexGrow={1}
                              fontWeight="normal"
                              align="right"
                            >
                              ₹{" "}
                              {`${(Number(payouts.connectorPayout) || 0).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}`}
                            </CustomTableCell>
                            <CustomTableCell
                              minWidth="100px"
                              flexGrow={1}
                              fontWeight="normal"
                            ></CustomTableCell>
                          </TableRow>
                          <TableRow
                            sx={{
                              height: "30px", // Set a smaller height
                            }}
                          >
                            <CustomTableCell minWidth="100px" flexGrow={1} fontWeight="normal">
                              Less : TDS @ {companyConfig.companyTDSPercent} %
                            </CustomTableCell>
                            <CustomTableCell
                              minWidth="100px"
                              flexGrow={1}
                              fontWeight="normal"
                              align="right"
                            >
                              ₹
                              {` ${(Number(payouts.tdsOnConnectorPayout) || 0).toLocaleString(
                                "en-IN",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )}`}
                            </CustomTableCell>
                            <CustomTableCell
                              minWidth="100px"
                              flexGrow={1}
                              fontWeight="normal"
                            ></CustomTableCell>
                          </TableRow>
                          {/* Net Connector Payout */}
                          <TableRow sx={{ backgroundColor: "rgba(51, 51, 51, 0.67)" }}>
                            <CustomTableCell
                              sx={{ color: "#ffffff" }}
                              minWidth="100px"
                              colSpan={2}
                              flexGrow={1}
                              fontWeight="bold"
                            >
                              Net Connector Payout
                            </CustomTableCell>
                            <CustomTableCell
                              sx={{ color: "#ffffff" }}
                              minWidth="100px"
                              flexGrow={1}
                              fontWeight="bold"
                              align="right"
                            >
                              ₹{" "}
                              {`${(Number(payouts.finalConnectorPayoutAmount) || 0).toLocaleString(
                                "en-IN",
                                { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                              )}`}
                            </CustomTableCell>
                          </TableRow>

                          {/* Net DSA Profit / Loss */}
                          <TableRow
                            sx={{
                              backgroundColor:
                                Number(
                                  payouts.providerPayoutAmount -
                                    payouts.dsaPayoutAmountD -
                                    payouts.connectorPayout
                                ) >= 0
                                  ? "rgba(51, 51, 51, 0.96)"
                                  : "red",
                            }}
                          >
                            <CustomTableCell
                              sx={{ color: "#ffffff" }}
                              minWidth="100px"
                              colSpan={2}
                              flexGrow={1}
                              fontWeight="bold"
                            >
                              {Number(
                                payouts.providerPayoutAmount -
                                  payouts.dsaPayoutAmountD -
                                  payouts.connectorPayout
                              ) > 0
                                ? "Net DSA Profit / Loss"
                                : "Net DSA Profit / Loss"}
                            </CustomTableCell>
                            <CustomTableCell
                              sx={{ color: "#ffffff" }}
                              minWidth="100px"
                              flexGrow={1}
                              fontWeight="bold"
                              align="right"
                            >
                              ₹{" "}
                              {`${(
                                Number(
                                  payouts.providerPayoutAmount -
                                    payouts.dsaPayoutAmountD -
                                    payouts.connectorPayout
                                ) || 0
                              ).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}`}
                            </CustomTableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    )}
                    {disbursements.length > 0 && <DisbursementTabs disbursements={disbursements} />}
                  </TableContainer>
                </Box>
              </Grid>
            </Grid>
          )}
        </Box>
      </Box>
    </DashboardLayout>
  );
}
BusinessEntry.propTypes = {
  data: PropTypes.object.isRequired,
  node: PropTypes.shape({
    rowIndex: PropTypes.number.isRequired,
  }).isRequired,
  uuid: PropTypes.string.isRequired, // Add uuid to propTypes
  api: PropTypes.shape({
    getDisplayedRowAtIndex: PropTypes.func.isRequired,
  }).isRequired,
};
